import DataGrid, { Column } from 'devextreme-react/data-grid';
import ScrollView from 'devextreme-react/scroll-view';
import { useState, useEffect } from 'react';
import AsyncCallHandler from '../../../../common/AsyncCallHandler';
import NEXUS_CONST from '../../../../common/constants';
import { KAIZENCONFIG } from '../../config';
import { alert } from 'devextreme/ui/dialog';
import Prompt from '../prompt/Prompt';

const Area = props => {
    const { category, site, app } = { ...props }
    const [refresh, setRefresh] = useState(new Date().getTime())
    const areaList = useAreaList(site, refresh);

    const scrollConfig = {
        showScrollbar: 'always',
        scrollByContent: false,
        scrollByThumb: true,
    }

    const handlers = {
    }

    if (areaList.isLoading) {
        return (
            <Prompt type="loading" message="Loading Area Data" />
        )
    }

    if (areaList.isError) {
        return (
            <Prompt type="error" message="Error loading Area Data" />
        )
    }

    return (
        <ScrollView {...scrollConfig} style={{ height: "80%" }}>
            <div className="sfinfo-section">
                <div className="component" style={{ minHeight: "230px", borderRadius: ".5rem" }}>
                    {areaList.data
                        &&
                        <DataGrid
                            dataSource={areaList.data}
                            allowColumnReordering={true}
                            showBorders={true}
                            {...KAIZENCONFIG.KAIZEN_AREA_GRID}
                            columns={KAIZENCONFIG.KAIZEN_AREA_COL}
                            {...handlers}
                        >
                        </DataGrid>
                    }

                </div>
            </div>
        </ScrollView>
    )
}

const useAreaList = (site, refresh) => {
    const [response, setResponse] = useState({ data: null, isLoading: true, isSuccess: false, isError: false, error: null });
    useEffect(() => {
        AsyncCallHandler(NEXUS_CONST.FETCH_KAIZEN_CELL_LIST + site, NEXUS_CONST.GET)
            .then(res => {
                if (res.status === 200) {
                    setResponse({ data: res.data, isLoading: false, isSuccess: true, isError: false, error: null })
                }
                else {
                    setResponse({ data: res.data, isLoading: false, isSuccess: false, isError: true, error: "Error Loading Area" })
                }
            })
    }, [refresh])
    return response
}

export default Area